import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import UserProfile from 'app/modules/auth/components/profile/UserProfile'
import UserList from 'app/modules/auth/user/UserList'
import CreateUser from 'app/modules/auth/user/CreateUser'
import EditUser from 'app/modules/auth/user/EditUser'
import RoleList from 'app/modules/auth/role/RoleList'
import CreateRole from 'app/modules/auth/role/CreateRole'
import EditRole from 'app/modules/auth/role/EditRole'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import TopBarProgress from 'react-topbar-progress-indicator'

const PrivateRoutes = () => {
  const AdminRoutes = lazy(() => import('app/modules/admin/AdminRoutes'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registration */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />

        {/* Dashboard */}
        <Route path='dashboard' element={<DashboardWrapper />} />

        {/* User Routes */}
        <Route path='/users' element={<UserList />} />
        <Route path='/user/create' element={<CreateUser />} />
        <Route path='/user-edit/:id' element={<EditUser />} />

        {/* Role Routes */}
        <Route path='/roles-list' element={<RoleList />} />
        <Route path='/role/create' element={<CreateRole />} />
        <Route path='/role-edit/:id' element={<EditRole />} />
        <Route path='/profile' element={<UserProfile />} />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />

        <Route
          path='admin/*'
          element={
            <SuspensedView>
              <AdminRoutes />
            </SuspensedView>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
